import { formatPhone } from '@/libs/util';

type Props = {
  data:
    | {
        patient_first_name: string;
        patient_last_name: string;
        patient_street_address: string;
        patient_city_address: string;
        patient_state: string;
        patient_zip: string;
        patient_phone_number: string;
        registration_code: string;
      }
    | undefined;
};

const AssistanceRequestPatientInfo = ({ data }: Props) => {
  if (!data) return null;

  return (
    <>
      <h2 className="mb-2 text-xl font-bold">
        Record history of {data.patient_first_name} {data.patient_last_name}
      </h2>
      <div className="mb-4 space-y-1">
        <p className="space-x-1.5">
          <strong>Street Address:</strong> <span>{data.patient_street_address}</span>
        </p>
        <p className="space-x-1.5">
          <strong>City:</strong> <span>{data.patient_city_address}</span>
        </p>
        <p className="space-x-1.5">
          <strong>State:</strong> <span>{data.patient_state}</span>
        </p>
        <p className="space-x-1.5">
          <strong>Zip:</strong> <span>{data.patient_zip}</span>
        </p>
        <p className="space-x-1.5">
          <strong>Phone:</strong> <span>{formatPhone(data.patient_phone_number)}</span>
        </p>
        <p className="space-x-1.5">
          <strong>Reg Code:</strong> <span>{data.registration_code}</span>
        </p>
      </div>
    </>
  );
};

export default AssistanceRequestPatientInfo;
